export const PRICE_CALCULATOR_ENDPOINT = '/assortments/pricing_calculator/';

export const WHITELISTED_EVENT_PARAMETERS = [
    'ticketPrice',
    'ticketQuantity',
    'passOnFees',
    'assortment',
];

export const FIELDS_TO_VALIDATE = ['ticketPrice', 'ticketQuantity'];
export const ERROR_MESSAGE_PROPS = ['ticketPriceError', 'ticketQuantityError'];

export const MAX_TICKET_QUANTITY = 500000;
export const MIN_TICKET_QUANTITY = 1;
export const MAX_TICKET_PRICE = 1000000;
